/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface TransactionAPI
 * @hideconstructor
 * @classdesc API class that is used to control transactional behaviour during API usage.
 * @example dashboard.getFeature('Transaction')
 */
define([], () => {
	class TransactionAPI {
		/**
		 * @public
		 * @function TransactionAPI#startTransaction
		 * @description Starts a new API transaction.
		 * @param {SetOption} [transactionToken] Parent transaction token
		 * @returns {SetOptions} transactionToken
		 */
		startTransaction() {}

		/**
		 * @public
		 * @deprecated
		 * @function TransactionAPI#startTransactionById
		 * @description Starts a new API transaction with the given transactionId.
		 * Use {@link TransactionAPI#startTransaction} unless a transactionId needs to be reused from a legacy transaction.
		 * @param {String} transactionId Unique transaction identifier
		 * @returns {SetOptions} transactionToken
		 */
		startTransactionById() {}

		/**
		 * @public
		 * @function TransactionAPI#endTransaction
		 * @description Ends an existing API transaction.
		 * @param {SetOptions} transactionToken
		 */
		endTransaction() {}

		/**
		 * @public
		 * @function TransactionAPI#getTransactionById
		 * @description Returns the transaction token from the specified unique transaction identifier.
		 * @returns {SetOptions} transactionToken
		 */
		getTransactionById() {}

		/**
		 * @public
		 * @function TransactionAPI#isValidTransaction
		 * @description Determines whether the token is a valid transaction.
		 * @param {SetOptions} transactionToken Transaction token
		 */
		isValidTransaction() {}

		/**
		 * @public
		 * @function TransactionAPI#registerTransactionHandler
		 * @description Registers an transaction handler for the existing API transaction.
		 * @param {SetOptions} transactionToken Transaction token
		 * @param {string} handlerId Unique handler identifier
		 * @param {TransactionHandler} handler Handler to be executed when the transaction is complete
		 * @param {Object} args Arguments to be passed to the TransactionHandler
		 * @returns {Promise} Returns a promise that is resolved once the handler is executed.
		 */
		registerTransactionHandler() {}

		/**
		 * @public
		 * @function TransactionAPI#getCurrentTransactionList
		 * @description Returns the list of currently active transaction tokens.
		 * @returns {SetOptions[]} Array of all active transaction tokens
		 */
		getActiveTransactionList() {}
	}

	return TransactionAPI;
});
